module.exports = __webpack_public_path__ + "static/media/15.11c4c2dd.png";